"use client";

import Vimeo from "@u-wave/react-vimeo";
import Image from "next/image";
import { useState } from "react";

export default function VimeoVideo({ videoId, thumb }) {
    const [videoClicked, setVideoClicked] = useState(false);

    return (
        <>
            {!videoClicked ? (
                <div
                    className="relative w-full z-0 aspect-w-16 aspect-h-9 rounded-xl overflow-hidden cursor-pointer"
                    onClick={() => setVideoClicked(true)}
                >
                    <Image
                        src={thumb}
                        alt={`Miniature pour vidéo ${videoId}`}
                        fill
                        style={{
                            objectFit: "cover",
                        }}
                        quality={80}
                        priority
                    />
                    <div className="absolute top-0 z-20 left-0 right-0 bottom-0 flex flex-col items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-[110px] h-[110px] text-white"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill="currentColor"
                                fillRule="evenodd"
                                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10"
                                clipRule="evenodd"
                                opacity=".5"
                            ></path>
                            <path
                                fill="currentColor"
                                d="m15.414 13.059l-4.72 2.787C9.934 16.294 9 15.71 9 14.786V9.214c0-.924.934-1.507 1.694-1.059l4.72 2.787c.781.462.781 1.656 0 2.118"
                            ></path>
                        </svg>
                    </div>
                </div>
            ) : (
                <Vimeo
                    video={videoId}
                    showByline={false}
                    color="8468e3"
                    showTitle={false}
                    showPortrait={false}
                    background={false}
                    speed
                    className="z-0 object-cover left-0 top-0 bottom-0 right-0 absolute"
                    dnt
                    responsive
                    autoplay
                    volume="100"
                />
            )}
        </>
    );
}
